<template>
  <div id="personHeader" class="content-box text-center">
    <div v-if="windowSize.width > windowSize.sizes.sm" class="picture">{{ intials }}</div>

    <h1 class="t-name">{{ name }}</h1>

    <div v-if="windowSize.width > 640" class="info text-semimuted">
      <div>
        <span style="margin-right: 20px">{{ firstRoleText }}</span>
        <span v-show="entity.person.city">{{ entity.person.city }}, {{ entity.person.country }}</span>
      </div>

      <div class="info text-semimuted">
        <span
          is="preview-list"
          list="Antal roller i direktioner, bestyrelser eller som ejer/stifter af danske firmaer"
          :clip="false"
          style="margin-right: 20px"
          class="fixed plausible-event-name=person+header+roles+click"
          :class="{ 'disabled': !entity.activeRelations.length }"
        >{{ entity.activeRelations.length | pluralize('aktive erhvervsroller', 'aktiv erhvervsrolle') }}</span>

        <span
          is="preview-list"
          list="Antal personer tilknyttet via fælles bestyrelser/direktioner eller fælles ejere/stiftede firmaer"
          :clip="false"
          style="margin-right: 20px"
          class="fixed plausible-event-name=person+header+network+click"
          :class="{ 'disabled': !networkCount }"
        >{{ networkCount | pluralize('personer', 'person') }} i netværk</span>

        <span
          is="preview-list"
          list="Antal firmaer, der er gået konkurs under 12 måneder efter personens udtræden"
          :clip="false"
          style="margin-right: 20px"
          class="fixed plausible-event-name=person+header+bankruptcies+click"
          :class="{ 'disabled': !entity.bankruptcies.length }"
        >{{ entity.bankruptcies.length | pluralize('konkursrelationer', 'konkursrelation') }}</span>
      </div>

      <div class="actions" style="margin-top: 20px;">
        <FollowButton
          :lassoId="entity.lassoId"
          class="plausible-event-name=person+follow+click"
          :name="name"
        />

          <LassoxLink
            path="dashboard"
            trackingEventName="person+full+profile+click"
            :dialogOptions="{ lassoxIntro:
              {
                title: 'Se fuld profil',
                text: 'Opret en gratis bruger nu og få adgang til den fulde profil. Se bl.a. alle ejerskaber, direktions- og bestyrelsesposter.',
                image: require('@/assets/img/signup-dialog-full-profile.png'),
                color: 'purple'
              }
            }">
          <Button
            theme="red"
            icon="person_rounded"
            label="Se fuld profil"
            style="margin-left: 8px"
          ></Button>
        </LassoxLink>
      </div>
    </div>

    <div v-else class="info text-semimuted">
      <div>
        <div>{{ firstRoleText }}</div>
        <div v-show="entity.person.city">{{ entity.person.city }}, {{ entity.person.country }}</div>
      </div>

      <div class="info text-semimuted">
        <span :class="{ 'disabled': !entity.activeRelations.length }">{{ entity.activeRelations.length | pluralize('aktive erhvervsroller', 'aktiv erhvervsrolle') }}</span>, <span :class="{ 'disabled': !networkCount }">{{networkCount | pluralize('personer', 'person') }} i netværk</span>, <span :class="{ 'disabled': !entity.bankruptcies.length }" style="white-space: nowrap">{{ entity.bankruptcies.length | pluralize('konkursrelationer', 'konkursrelation') }}</span>
      </div>

      <div class="actions">
        <FollowButton
          :lassoId="entity.lassoId"
          :name="name"
          class="plausible-event-name=person+follow+click"
          style="margin-top: 20px"
        />

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import FollowButton from '@/components/FollowButton.vue'
import Button from '@/components/Button.vue'
import windowSize from '@/window-size'
import LassoxLink from './LassoxLink.vue';

export default {
  name: 'personHeader',

  components: {
    FollowButton,
    Button,
    LassoxLink,
  },

  props: {
    entity: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {
      windowSize,
    }
  },

  computed: {
    name: function () {
      return this.entity.person.firstName + ' ' + this.entity.person.lastName
    },

    intials: function () {
      var allInitials = this.name.split(' ').map(s => (s.substring(0, 1))).join('').toUpperCase()
      if (allInitials.length > 3) return allInitials.slice(0, 1) + allInitials.slice(2)
      else return allInitials
    },

    startedBefore1980: function () {
      return this.entity.startDate ? new Date(this.entity.startDate).getFullYear() < 1980 : true
    },

    firstRoleText: function () {
      if (this.startedBefore1980) return 'Første erhvervsrolle over 20 år siden'
      else return 'Første erhvervsrolle i ' + Vue.filter('date')(this.entity.startDate, '%Y')
    },

    networkCount: function () {
      return this.entity.network ? this.entity.network.total : '-'
    },
  },
}
</script>

<style lang="scss" scoped>
#personHeader {
  & > .info {
    & > .actions {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>

<style scoped lang="less">
@import (reference) '~@oldShared/lasso/style/utilities/mixin';
  #personHeader {
    position: relative;
    padding: 50px 30px 30px 30px;

    .picture {
      position: absolute;
      top: -35px;
      left: 50%;
      margin-left: -35px;
      width: 75px;
      height: 75px;
      border-radius: 50%;
      background: #fff;
      color: rgba(34, 34, 34, .4);
      font-size: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      -webkit-box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
      -moz-box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
    }

    span.disabled {
      color: #acacac;
    }

    h1 {
      color: #212121;
      font-size: 30px;
      line-height: 30px;
      font-weight: 500;
      margin: 0 0 20px 0;
    }

    .info {
      line-height: 25px;
    }
  }

  #app.min-sm #personHeader {
    padding-top: 80px;

    .picture {
      top: -50px;
      left: 50%;
      margin-left: -50px;
      width: 100px;
      height: 100px;
      font-size: 22px;
    }
  }

</style>
